module.exports = __webpack_public_path__ + "img/bagBlack.6e531c9f.svg";